module.exports = __webpack_public_path__ + "img/icon-qrcode-border-tl.04e16147.svg";